"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.Input = exports.InputContainer = exports.AmountContainer = exports.Label = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _input = require("@creditas-lab/input");

var _typography = require("@creditas-lab/typography");

var _GhostButton = require("../GhostButton");

var Container = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 16px 0 12px 0;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin: 24px 0 0 0;\n  "]))));

exports.Container = Container;
var Label = (0, _stylitas.styled)(_typography.Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-bottom: 8px;\n  "]))));
exports.Label = Label;

var AmountContainer = _stylitas.styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.AmountContainer = AmountContainer;

var InputContainer = _stylitas.styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

exports.InputContainer = InputContainer;

var inputStyled = function inputStyled(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n\n    opacity: 1;\n    padding: 0 0 0 4px;\n\n    ", "\n\n    &:disabled {\n      color: ", ";\n      -webkit-text-fill-color: ", ";\n    }\n  "])), _styleUtilities.typography['2xl'](theme), _styleUtilities.media.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      ", ";\n    "])), _styleUtilities.typography['2xl'](theme)), theme.colorNeutral90, theme.colorNeutral90);
};

var InputStyled = (0, _stylitas.styled)(_input.Input)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n"])), inputStyled);
exports.Input = InputStyled;
var ToggleButton = (0, _stylitas.styled)(_GhostButton.GhostButton)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  overflow-x: visible;\n"])));
exports.ToggleButton = ToggleButton;